import useJwt from '@/auth/jwt/useJwt'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
  // return localStorage.getItem('userData') && localStorage.getItem('accessToken')
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/** Normalize stored admin token for Authorization header. */
export const getAccessToken = () => {
  let token = localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName) || ''
  if (!token) {
    try {
      const userData = JSON.parse(localStorage.getItem('userData') || 'null')
      token = userData?.token || ''
    } catch {
      token = ''
    }
  }
  token = String(token).trim().replace(/^Bearer\s+/i, '')
  if (!token || token === 'null' || token === 'undefined') return ''
  return token
}

export const clearAuthSession = () => {
  localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
  localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
  localStorage.removeItem('userData')
}

/** Routes that do not require a logged-in session (auth pages, errors). */
export const isPublicRoute = to => to.matched.some(record => record.meta.layout === 'full')

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = () => {
  if (isUserLoggedIn()) return { name: 'my-poda-dashboard' }
  return { name: 'auth-login' }
}
